import { Navigate, useNavigate } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import { FoliarAdvicePage } from '@practium/features/recommendations';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';

export const AddFoliarAdvicePageClient = () => {
	const navigate = useNavigate();
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';

	const canCreate = abilities.can('create', subject);

	if (!canCreate) return <Navigate to="/recomendacoes" replace />;

	return (
		<FoliarAdvicePage
			onBack={() => navigate(getRecommendationsListPath('foliar'))}
			initialMode="add"
		/>
	);
};
